import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './occupation.reducer';

export const OccupationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const occupationEntity = useAppSelector(state => state.occupation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="occupationDetailsHeading">
          <Translate contentKey="apiLocationApp.occupation.detail.title">Occupation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.occupation.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.occupation.date">Date</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.occupation.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.occupation.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.geographyCode}</dd>
          <dt>
            <span id="totalAllUsualResidents">
              <Translate contentKey="apiLocationApp.occupation.totalAllUsualResidents">Total All Usual Residents</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.totalAllUsualResidents}</dd>
          <dt>
            <span id="managersDirectorsOfficials">
              <Translate contentKey="apiLocationApp.occupation.managersDirectorsOfficials">Managers Directors Officials</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.managersDirectorsOfficials}</dd>
          <dt>
            <span id="professionalOccupations">
              <Translate contentKey="apiLocationApp.occupation.professionalOccupations">Professional Occupations</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.professionalOccupations}</dd>
          <dt>
            <span id="associateProfessionalTechnical">
              <Translate contentKey="apiLocationApp.occupation.associateProfessionalTechnical">Associate Professional Technical</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.associateProfessionalTechnical}</dd>
          <dt>
            <span id="administrativeSecretarial">
              <Translate contentKey="apiLocationApp.occupation.administrativeSecretarial">Administrative Secretarial</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.administrativeSecretarial}</dd>
          <dt>
            <span id="skilledTradesOccupations">
              <Translate contentKey="apiLocationApp.occupation.skilledTradesOccupations">Skilled Trades Occupations</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.skilledTradesOccupations}</dd>
          <dt>
            <span id="caringLeisureService">
              <Translate contentKey="apiLocationApp.occupation.caringLeisureService">Caring Leisure Service</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.caringLeisureService}</dd>
          <dt>
            <span id="salesCustomerService">
              <Translate contentKey="apiLocationApp.occupation.salesCustomerService">Sales Customer Service</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.salesCustomerService}</dd>
          <dt>
            <span id="processPlantMachineOperatives">
              <Translate contentKey="apiLocationApp.occupation.processPlantMachineOperatives">Process Plant Machine Operatives</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.processPlantMachineOperatives}</dd>
          <dt>
            <span id="elementaryOccupations">
              <Translate contentKey="apiLocationApp.occupation.elementaryOccupations">Elementary Occupations</Translate>
            </span>
          </dt>
          <dd>{occupationEntity.elementaryOccupations}</dd>
        </dl>
        <Button tag={Link} to="/occupation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/occupation/${occupationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OccupationDetail;
